/**
 * Shared option-list helper for the share filter field groups.
 */
import type { ComboboxItem } from '@mantine/core';
import type { TFunction } from 'i18next';

/** Maps enum value strings to translated select options. */
function toOptions(
  values: string[],
  prefix: string,
  t: TFunction
): ComboboxItem[] {
  return values.map((value) => ({
    value,
    label: t(`${prefix}.${value}`, { defaultValue: value }),
  }));
}

/**
 * Narrows a canonical value list to the owner's shared subset, preserving the
 * canonical order. An empty / missing `allowed` list means "no restriction" —
 * the full list is returned (so the owner config form keeps showing all values).
 */
export function restrictValues(all: string[], allowed?: string[]): string[] {
  return allowed && allowed.length > 0
    ? all.filter((value) => allowed.includes(value))
    : all;
}

/**
 * Builds translated select options for a canonical value list narrowed to the
 * owner's shared subset (see {@link restrictValues}).
 */
export function restrictedOptions(
  all: string[],
  allowed: string[] | undefined,
  prefix: string,
  t: TFunction
): ComboboxItem[] {
  return toOptions(restrictValues(all, allowed), prefix, t);
}
